import DirecteurMultiple from "./DirecteurMultiple.component";

export default DirecteurMultiple;